module.exports = __webpack_public_path__ + "img/number-black-6.0e21ca1d.png";